import { SAVE_BEACON, SELECT_BEACON } from '../constants/beacon.constants';

export const selectBeacon = beacon => ({ type: SELECT_BEACON, beacon});
export const saveBeacon = beacon => ({ type: SAVE_BEACON, beacon});